import { Pipe, PipeTransform } from '@angular/core';
import { formatInTimeZone } from 'date-fns-tz';

import { TimezoneTagToNameMap } from '@sondermind/utilities/time-and-date';

@Pipe({
  name: 'formatRequestedTimeSlot',
  standalone: true,
})
export class RequestedTimeSlotPipe implements PipeTransform {
  transform(date: Date, timeZone: string, longMonth: boolean = false): string {
    if (date) {
      if (timeZone && TimezoneTagToNameMap[timeZone]) {
        const formatStr = longMonth ? 'EEE, MMMM d \'at\' h:mm a z' : 'EEE, MMM d, \'at\' h:mm a z';
        return formatInTimeZone(date, timeZone, formatStr);
      }

      return 'Invalid timezone for date';
    }

    // Invalid date
    return '';
  }
}
